module.exports = __webpack_public_path__ + "static/media/hp-home-banner-mobile-@1x.ae4aca2d.jpg";